import React from 'react';
import { Grid } from '@mui/material';
import dayjs from 'dayjs';
import { RangePicker } from '../../range-picker/RangePicker';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoPeriodo: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange }) => {
    const temValor = valor !== '' && valor !== null && valor !== undefined;

    return (
        <Grid item xs={12} sm={12} key={indice.idIndice}>
            <RangePicker
                labelInicial={`${indice.nomeIndice} INICIAL`}
                labelFinal={`${indice.nomeIndice} FINAL`}
                valueInicial={temValor ? dayjs(valor?.split(' | ')[0], 'YYYY-MM-DD') : null}
                valueFinal={temValor ? dayjs(valor?.split(' | ')[1], 'YYYY-MM-DD') : null}
                disabled={disabled}
                retornoData={(dataInicial, dataFinal) => {
                    if (dataInicial !== null && dataFinal !== null) {
                        onChange(`${dataInicial.format('YYYY-MM-DD')} | ${dataFinal.format('YYYY-MM-DD')}`);
                    } else if (dataInicial !== null && dataFinal === null) {
                        onChange(dataInicial.format('YYYY-MM-DD'));
                    } else {
                        onChange('');
                    }
                }}
            />
        </Grid>
    );
};
